var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check Outlined / selected"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 3.25,
    stroke: "#01010B",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.54998 17.275C9.43332 17.275 9.32098 17.254 9.21298 17.212C9.10432 17.1707 9.00832 17.1084 8.92498 17.025L4.74998 12.85C4.59998 12.7 4.52898 12.5207 4.53698 12.312C4.54565 12.104 4.61665 11.925 4.74998 11.775C4.89998 11.625 5.07932 11.55 5.28798 11.55C5.49598 11.55 5.66665 11.625 5.79998 11.775L9.54998 15.525L18.2 6.87502C18.3333 6.72502 18.5083 6.65002 18.725 6.65002C18.9417 6.65002 19.1167 6.72502 19.25 6.87502C19.4 7.02502 19.475 7.20402 19.475 7.41202C19.475 7.62069 19.4 7.80002 19.25 7.95002L10.175 17.025C10.0917 17.1084 9.99598 17.1707 9.88798 17.212C9.77932 17.254 9.66665 17.275 9.54998 17.275Z",
    fill: "#01010B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.189306742461e94d72f1fcb6fb5abe6c.svg";
export { ForwardRef as ReactComponent };